<template>
    <div class="yesterdayList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>销售业绩榜单</el-breadcrumb-item>
            <el-breadcrumb-item>直客昨天签单之星</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="project-list-table" :data="sellerList" stripe border>
            <el-table-column label="直客" align='center' width="100px">
              <template scope="scope">
                    <span>{{scope.row[propertyNameList[0]]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="姓名" align='center'>
                <template scope="scope">
                    <span>{{scope.row[propertyNameList[1]]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="昨日签单金额" align='center'  width="120px">
                <template scope="scope">
                    <span>{{scope.row[propertyNameList[2]]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="昨日签单客户" align='center'  width="120px">
                <template scope="scope">
                    <span>{{scope.row[propertyNameList[3]]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <el-button size="small" type="info" @click="openLink(scope.$index)">编辑</el-button>
                    <!-- <el-button size="small" type="danger" @click="deleteProject(scope.$index)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <!--编辑弹框-->
        <el-dialog v-if="editForm" title="编辑" v-model="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false">
            <el-form :model="editForm" ref="editForm" label-width="100px">
                <el-form-item label="区域">
                    <el-input v-model="editForm[propertyNameList[0]]" auto-complete="off" placeholder="请输入区域名称"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="editForm[propertyNameList[1]]" auto-complete="off" placeholder="请输入销售人员姓名"></el-input>
                </el-form-item>
                <el-form-item label="昨天签单金额">
                    <el-input v-model="editForm[propertyNameList[2]]" auto-complete="off" placeholder="请输入签单金额"></el-input>
                </el-form-item>
                <el-form-item label="昨天签单客户">
                    <el-input v-model="editForm[propertyNameList[3]]" auto-complete="off" placeholder="请输入签单客户"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editSubmit('editForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--end-->
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "yesterdayList",
    data() {
        return {
            allData: null,
            sellerList: null,
            propertyNameList: ['直客','姓名','昨日签单金额','昨日签单客户'],
            dialogFormVisible: false,
            editForm: null,
            editIndex: -1,
            partName: 'yesterdays-top-zhike'
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        _getProjectList() {
            let self = this;
            this.$http.get(CONFIG.HOST + "/salesList/getSalesList" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    var o = TOOL.formatObj(result.data);
                    this.allData = o;
                    this.sellerList = o[self.partName];
                    // this.propertyNameList = TOOL.getPropertyName(o, self.partName);
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        openLink(arrIndex){
            this.dialogFormVisible = true;
            var tmp = JSON.stringify(this.sellerList[arrIndex]);
            this.editForm = JSON.parse(tmp);
            this.editIndex = arrIndex;
        },
        editSubmit(formName){
            var tmp = JSON.stringify(this.editForm),
                self = this;
            self.$set(this.sellerList,this.editIndex, JSON.parse(tmp));
            self.dialogFormVisible = false;
            self.updateData({
              key: self.partName,
              value: JSON.stringify(self.sellerList)
            }, ()=>{
              self._getProjectList();
            });
        },
        // deleteProject(projectId) {
        //     let self =this;
        //     this.sellerList.splice(projectId);
        //     // 修改本地数据
        //     this.allData[self.partName] = JSON.stringify(this.sellerList);
        //     // ------end------
        //     // 向服务器同步数据
        //     self.updateData({
        //       key: self.partName,
        //       value: JSON.stringify(self.sellerList)
        //     }, ()=>{
        //       self._getProjectList();
        //     });
        // },
        updateData(data, callback){
          this.$http.put(CONFIG.HOST + "/salesList/updateSale", data).then((response)=>{
              let result = response.body;
              if (result && result.status === 1) {
                  callback();
              } else {
                  this.$notify.error({
                      message: result.message
                  });
              }
          }, (response)=>{
              console.log(response);
          });
        },
        _init() {
            this._getProjectList();
        }
    }
};
</script>
<style lang="less">
    .yesterdayList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .project-list-table{
            min-width: 980px;
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
    }
</style>



// WEBPACK FOOTER //
// ZhikeYesterdayList.vue?11d0ad86